<template>
  <div>
    <div class="content-header mb-3">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h2 class="m-0 poppins-medium mb-2">
              <span class="mr-5">Crear Guías {{ madre !== null ? madre.numero : ''}}</span>
            </h2>
          </div>
        </div>
      </div>
    </div>    
    
    <div class="card" v-if="actual == 1">
      <div class="card-body">
        <div v-if="hijas.length > 0" class="alert alert-primary btn-color-principal" role="alert">
          <p>Guías generadas:</p>
          <p class="m-0" v-for="i in hijas" :key="i.id">{{ i.numero }}</p>
        </div>

        <form @submit.prevent="guardar">
          <div class="text-right">
            <a href="#" @click.prevent="actual = 2" class="color-verde poppins_regular">
              Crear desde xls
            </a>
          </div>
          <div class="alert alert-danger" id="mensajeCobertura" role="alert" v-if="errorCobertura !== null">
            <b>Alerta:</b> {{ errorCobertura }}
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-6">
              <label for="inputOrden" class="mb-1">Número de orden: *</label>
              <input type="text" :required="true" class="form-control form-control-sm" id="inputOrden" v-model="form.orden">
            </div>
            <div class="col-sm-6">
              <label for="selectReco" class="mb-1">Número de recolección:</label>
              <select id ="selectReco" v-model="solicitud" class="form-control form-control-sm" :required="true" @change="setSolicitud">
                <option value="">----------</option>
                <option v-for="i in catalogo.recoleccion" :key="i.id" :value="i">{{ i.numero }} - {{ i.fecha_programada }} ({{ i.codigo }})</option>
              </select>
            </div>
          </div>

          <div class="my-4">
            <span class="font-weight-bold mr-5">
              <i class="fa fa-user"></i> Destinatario (Quien recibe)
            </span>
          </div>

          <div class="form-group row mb-1">
            <div class="col-sm-12 my-3">
              <div class="form-check form-check-inline">
                <input type="radio" id="btipo1" value="1" class="form-check-input" v-model="btipo">
                <label for="btipo1" class="form-check-label"> Buscar por identificación</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" id="btipo2" value="2" class="form-check-input" v-model="btipo">
                <label for="btipo2" class="form-check-label">Buscar por nombre</label>
              </div>
            </div>
          </div>
          
          <div class="form-group row mb-1">
            <div class="col-sm-6">
              <label for="inputIdentificacion" class="col-form-label col-12">{{ btipo == 1?'Número de registro de cliente':'Nombre'}}:</label>
              <input type="text" class="form-control" v-model="form.identificacion" :placeholder="btipo== 1 ? '0000000 - 0':'Ej: Nombre'">
            </div>
            <div class="col-sm-4">
              <button type="button" class="btn btn-lg btn-color-principal btn_guia" title="Buscar destinatario" @click="getCliente" :disabled="btnCliente">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnCliente"
                ></span>
                <i v-else class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <div class="form-group row mt-3" v-if="bc == 0">
            <div class="col-sm-12">
          
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="inlineRadioOptions" id="inlineRadio1" :value-true="1" :value-false="0" v-model="form.ccliente">
                <label class="form-check-label" for="inlineRadio1"> Permitir guardar el destinatario</label>
              </div>
            </div>
          </div>

          <div class="form-group row mb-1">
            <div class="col-sm-6">
              <label for="inputNombre" class="col-sm-12 col-form-label">Nombre: *</label>
              <input type="text" id="inputNombre" :required="true" v-model="form.nombre" class="form-control form-control-sm">
            </div>
            <div class="col-sm-6">
              <label for="inputCorre" class="col-sm-12 col-form-label">Correo remitente(quién envía):</label>
              <input type="text" id="inputCorreo" :required="true" v-model="form.correo" class="form-control form-control-sm">
            </div>
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-6">
              <label for="inputTelefono" class="col-sm-12 col-form-label">Teléfono: *</label>
              <input type="text" id="inputTelefono" :required="true" v-model="form.telefono" class="form-control form-control-sm">
            </div>

          </div>

          <div class="form-group row mb-1">
            <div class="col-sm-12">
              <label for="inputDireccion" class="col-sm-12 col-form-label">Dirección: *</label>
              <input type="text" id="inputDireccion" :required="true" v-model="form.direccion" class="form-control form-control-sm" :readonly="this.tipo_entrega.agencia_origen == 1">
            </div>
          </div>
          <div class="form-group row mb-3" v-if="bc == 1">
            <div class="col-sm-12">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="usarclie" value="option1" v-model="usarclie">
                <label class="form-check-label" for="usarclie"> Utilizar datos de destinatario para llenar el municipio y departamento.</label>
              </div>
            </div>
          </div>
          <p class="font-weight-bold my-4">
            <i class="fa fa-list-alt"></i> Otros datos
          </p>
          <p class="alert alert-danger py-2" v-if="errorRecolecta != null" v-html="errorRecolecta"></p>
          <p class="alert alert-danger py-2" v-if="validaMunicipioEntrega">
            No hay municipios que apliquen el tipo de entrega seleccionado.
          </p>
          <div class="form-group row mb-1">
            <div class="col-sm-6">
              <label for="selectTservicio" class="mb-1">Tipo de servicio:</label>
              <select id="selectTservicio" :required="true" class="form-control form-control-sm" v-model="form.guia_tipo_servicio_id">
                <option value="">----------</option>
                <option v-for="i in catalogo.tipo_servicio" :key="i.id" :value="i.id">{{ i.descripcion }}</option>
              </select>
            </div>
            <div class="col-sm-6">
              <label for="selectTservicio" class="mb-1">Tipo de entrega:</label>
              <select id="selectTservicio" :required="true" class="form-control form-control-sm" v-model="form.guia_tipo_entrega_id" @change="validarTiempo" disabled>
                <option value="">----------</option>
                <option v-for="i in catalogo.tipo_entrega" :key="i.id" :value="i.id">{{ i.codigo }} - {{ i.descripcion }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-sm-6 pt-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form.con_seguro" id="defaultCheck1" :true-value="1" :false-value="0">
                <label class="form-check-label" for="defaultCheck1">
                  Comprar seguro (costo adicional)
                </label>
              </div>
            </div>
            <div class="col-sm-6 pt-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form.con_liquidacion_documento" id="defaultCheck2" :true-value="1" :false-value="0">
                <label class="form-check-label" for="defaultCheck2">
                  Liquidación de documentos (costo adicional)
                </label>
              </div>
            </div>
          </div>
          <template v-if="form.con_liquidacion_documento == 1">
            <p class="font-weight-bold my-4">
              <i class="fa fa-list-alt"></i> Detalle de documentos
            </p>
            <div class="form-group row mb-1">
              <div class="col-lg-3">
                <label for="selectTdoc" class="mb-1">Tipo de documento:</label>
                <select id="selectTdoc" class="form-control form-control-sm" v-model="documento.tipo_id">
                  <option value="">----------</option>
                  <template v-for="i in catalogo.tipo_documento">
                    <option :key="i.id" :value="i.id">{{ i.descripcion }}</option>
                  </template>
                </select>
              </div>
              <div class="col-lg-3">
                <label for="selectum" class="mb-1">Número:</label>
                <input type="text" maxlength="75" id="inputPeso" v-model="documento.numero" class="form-control form-control-sm">
              </div>
              <div class="col-lg-3">
                <label for="inputContenido" class="mb-1">Observaciones:</label>
                <input type="text" maxlength="250" class="form-control form-control-sm" v-model="documento.observaciones">
              </div>
              <div class="col-lg-3 my-auto"><br>
                <button v-if="reg === ''" type="button" class="btn btn-block btn-color-principal btn-lg float-right " @click="agregarDocumento" title="Agregar documento">
                  <i class="fa fa-save"></i> Agregar
                </button>
              </div>
            </div>
            <div class="form-group row mt-2 mb-1">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered table_style">
                    <thead>
                      <tr class="bg-light">
                        <th scope="col" class="text-center">#</th>
                        <th scope="col">Tipo de documento</th>
                        <th scope="col">Número</th>
                        <th scope="col">Observaciones</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i, idx) in form.documento" :key="idx">
                        <td class="text-center">{{ idx+1 }}</td>
                        <td>{{ i.ntipo }}</td>
                        <td>{{ i.numero }}</td>
                        <td>{{ i.observaciones }}</td>
                        <td class="text-center">
                          <a href="javascript:;" v-if="reg === ''" class="text-danger font-weight-bold" @click="eliminaDocumento(idx)">
                            <i class="fa fa-times"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
          </template>
          <div class="form-group row mb-1">
            <div class="col-sm-6" v-if="form.guia_tipo_servicio_id == 2">
              <label for="inputCodMonto" class="mb-1">Monto a cobrar CCE:</label>
              <input type="number" :required="true" id="inputCodMonto" step="0.01" class="form-control form-control-sm" v-model="form.cod_monto">
            </div>
            <div class="col-sm-6" v-if="form.con_seguro == 1">
              <label for="inputValor" class="mb-1">Valor del producto asegurado:</label>
              <input type="number" :required="true" id="inputValor" step="0.01" class="form-control form-control-sm" v-model="form.monto">
            </div>
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-6" v-if="this.tipo_entrega.agencia_origen == 1">
              <label for="selectDepto" class="mb-1">Agencia de origen:</label>
              <select id="selectDepto" class="form-control form-control-sm" v-model="form.agencia_origen_id" :required="true">
                <option value="">----------</option>
                <option v-for="i in catalogo.bodega" :value="i.bodega" :key="i.bodega">{{ i.nombre }}</option>
              </select>
            </div>
          
            <div class="col-sm-6" v-if="this.tipo_entrega.agencia_destino == 1">
              <label for="selectDepto" class="mb-1">Agencia de destino:</label>
              <select id="selectDepto" class="form-control form-control-sm" v-model="agenciaDestino" @change="setAgenciaDestino" :required="true">
                <option value="">----------</option>
                <option v-for="i in catalogo.bodega" :value="i" :key="i.bodega">{{ i.nombre }}</option>
              </select>
            </div>
          </div>

          <div class="form-group row mb-1" v-if="this.tipo_entrega.agencia_destino == 0">
            <div class="col-sm-6">
              <label for="selectDepto" class="mb-1">Departamento:</label>
              <select id="selectDepto" class="form-control form-control-sm" v-model="depto">
                <option value="">----------</option>
                <option v-for="i in catalogo.departamento" :key="i.id" :value="i.id">{{ i.nombre }}</option>
              </select>
            </div>
            <div class="col-sm-6">
              <label for="selectMunicipio" class="mb-1">Municipio:</label>
              <select id="selectMunicipio" class="form-control form-control-sm" :required="true" v-model="form.municipio_id">
                <option value="">----------</option>
                <option v-for="i in municipios" :key="i.id" :value="i.id">{{ i.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-6" v-if="this.tipo_entrega.agencia_destino == 0">
              <label for="selectPoblado" class="mb-1">Poblado / Cantón:</label>
              <select id="selectPoblado" class="form-control form-control-sm" v-model="form.poblado_id">
                <option value="">----------</option>
                <option v-for="i in poblados" :key="i.id" :value="i.id">{{ i.descripcion }}</option>
              </select>
            </div>
            <div class="col-sm-6">
              <label for="inputContacto" class="mb-1">Contacto:</label> 
              <input type="text" class="form-control form-control-sm" v-model="form.contacto">
            </div>
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-12">
              <label for="inputreferencia" class="mb-1">Referencia de dirección de entrega:</label>
              <input type="text" id="inputreferencia" class="form-control form-control-sm" v-model="form.referencia">
            </div>
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-12">
              <label for="inputIndicacion" class="mb-1">Indicaciones especiales para la entrega:</label>
              <input type="text" id="inputIndicacion" class="form-control form-control-sm" v-model="form.indicaciones">
            </div>
          </div>
          <div class="form-group row mt-2 mb-1" v-if="reg !== ''">
            <div class="col-sm-12">
              <div class="alert alert-primary btn-color-principal">
                ¿Ha terminado de ingresar todas sus guías?<br>
                Por favor confirmar su recolecta # <b>{{ recolecta.numero }}</b> en el seguiente botón.
                <button type="button" class="btn btn-sm btn-primary btn-color-principal" @click="confirmar">
                  Confirmar recolecta
                </button>
              </div>
            </div>
          </div>
          <template v-if="form.guia_tipo_servicio_id == 3">
            <p class="font-weight-bold mb-1 my-4">
              <i class="fa fa-list-alt"></i> Datos de facturación
            </p>

            <div class="form-group row mb-3">
              <div class="col-md-6">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="facCF" v-model="cltTipo" value="1" class="custom-control-input">
                  <label class="custom-control-label" for="facCF">Consumidor Final</label>
                </div>

                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="facIndentificacion" v-model="cltTipo" value="2" class="custom-control-input">
                  <label class="custom-control-label" for="facIndentificacion">Comprobante de crétido fiscal</label>
                </div>
              </div>
              <div class="col-md-6" v-if="cltTipo == 2">
                <div class="text-center" v-if="cltCargando">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div><br>
                  <small class="text-muted">Comprobando número de identificación.</small>
                </div>
                <template v-else>
                  <div v-if="clt.origen != 3">
                    Nombre: {{ clt.nombre }}<br>
                    Dirección: {{ clt.direccion }}
                  </div>
                </template>
              </div>
            </div>

            <div class="form-group row mb-3">
              <div class="col-md-6 mb-3">
                <div v-if="cltTipo == 2">
                  <label for="cltIndentificacion" class="mb-1">Identificación: <span class="text-danger font-weight-bold">*</span></label> 
                  <input
                    type="text"
                    @blur="obtenerCliente"
                    class="form-control form-control-sm"
                    v-model="cltNit"
                    placeholder="Identificación del cliente a facturar"
                    :required="true"
                  >
                </div>
              </div>
              
              <template v-if="cltTipo == 2 && !cltCargando">
                  <div class="col-md-6 mb-3" v-if="clt.origen == 3">
                    <label for="cltNombre" class="mb-1">Nombre: <span class="text-danger font-weight-bold">*</span></label> 
                    <input type="text" 
                      class="form-control form-control-sm" 
                      v-model="clt.nombre" 
                      placeholder="Nombre del cliente a facturar" 
                      :required="true"
                    >
                  </div>

                  <div class="col-md-6 mb-3" v-if="clt.origen == 2 || clt.origen == 3">
                    <label for="cltNombre" class="mb-1">Correo:</label> 
                    <input type="text"
                    class="form-control form-control-sm"
                    v-model="clt.correo"
                    placeholder="Correo del cliente (Opcional)">
                  </div>

                  <div class="col-md-6 mb-3" v-if="clt.origen == 3">
                    <label for="cltDireccion" class="mb-1">Dirección: <span class="text-danger font-weight-bold">*</span></label> 
                    <input type="text" 
                      placeholder="Dirección del cliente"
                      class="form-control form-control-sm"
                      v-model="clt.direccion"
                      :required="true"
                    >
                  </div>

              </template>
            </div>

            
          </template>
          <p class="font-weight-bold my-4">
            <i class="fa fa-list-alt"></i> Detalle de bultos
          </p>
          <div class="alert alert-info" v-if="getPesoMaximo">
            Se han registrados bultos que execeden al peso máximo de <b>{{ config.peso_maximo }}</b> libras, esto ocasionará cargos adicionales. 
          </div>
          <div class="form-group row mb-1">
            <div class="col-sm-6 col-md-2 col-lg-1">
              <label for="inputPeso" class="mb-1">Peso:</label>
              <input type="number" step="0.01" id="inputPeso" v-model="guia.peso" class="form-control form-control-sm">
            </div>
            <div class="col-sm-6 col-md-3 col-lg-2">
              <label for="selectum" class="mb-1">Unidad medida:</label>
              <select id="selectum" class="form-control form-control-sm" v-model="guia.unidad_medida_id">
                <option value="">----------</option>
                <template v-for="i in catalogo.unidad_medida">
                  <option v-if="i.peso == 1" :key="i.id" :value="i.id">{{ i.nombre }}</option>
                </template>
              </select>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <label for="inputContenido" class="mb-1">Contenido:</label>
              <input type="text" class="form-control form-control-sm" v-model="guia.contenido">
            </div>
            <div class="col-sm-6 col-md-6 col-lg-3 my-auto"><br>
              <button v-if="reg === ''" type="button" class="btn btn-block btn-color-principal btn-lg" @click="agregarDetalle">
                <i class="fa fa-plus"></i> Agregar bulto
              </button>
            </div>
          </div>
          <div class="form-group row mt-2 mb-1">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-sm table-bordered table_style">
                  <thead>
                    <tr class="bg-light">
                      <th scope="col" class="text-center">#</th>
                      <th scope="col">Peso</th>
                      <th scope="col">Unidad medida</th>
                      <th scope="col">Contenido</th>
                      <th scope="col">Peso Adicional</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(i, idx) in form.guias" :key="idx">
                      <td class="text-center">{{ idx+1 }}</td>
                      <td>{{ i.peso }}</td>
                      <td>{{ i.nunidad }}</td>
                      <td>{{ i.contenido }}</td>
                      <td>{{ i.peso_adicional }}</td>
                      <td class="text-center">
                        <a href="#"
                          class="mr-5" 
                          @click.prevent="duplicar(idx)"
                          v-if="parseInt(form.guia_tipo_servicio_id) == 1">
                          <i class="fa fa-copy"></i>
                        </a>
                        <a href="javascript:;" v-if="reg === ''" class="text-danger font-weight-bold" @click="eliminaDetalle(idx)">
                          <i class="fa fa-times"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="form-group row mb-1" v-if="autorizado || !validaMunicipioEntrega || errorCobertura === null">
            <div class="col-sm-12 text-right">
              <button type="submit" class="btn btn-lg btn-success" :disabled="btnGuardar" v-if="reg == ''">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnGuardar"
                ></span>
                <span v-else>
                  <i class="fa fa-save"></i> Guardar
                </span>
              </button>
              <a href="javascript:;" v-else type="button" class="btn btn-lg btn-secondary mx-1" @click="nuevo">
                <i class="fa fa-refresh"></i> Nuevo
              </a>
              <a :href="UrlBase+'/madre/get_impresion/'+reg" v-if="reg !== ''" target="_blank" type="button" class="btn btn-lg btn-success btn-color-principal">
                <i class="fa fa-print"></i> Imprimir
              </a>
            </div>
          </div>
        </form>
        <GuiaRecoleccionConfirmar :reco="recolecta"/>
        <div class="modal" id="mdlResultado" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Resultado</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Identificación</th>
                      <th>Nombre</th>
                      <th>Dirección</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(i,idx) in listaCliente" :key="i.id">
                      <td>{{ idx+1}}</td>
                      <td>
                        <a
                          href="#"
                          @click.prevent="setCliente(i)">{{ i.identificacion }}</a></td>
                      <td>{{ i.nombre }}</td>
                      <td>{{ i.direccion }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GuiaMadreXls v-if="actual == 2" @regresar="actual = 1"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import GuiaCatalogo from '../mixins/GuiaCatalogo.js';
  import Notificacion from '../mixins/Notificacion.js';
  import GuiaMadreXls from './GuiaMadreXls.vue';
  import GuiaRecoleccionConfirmar from './GuiaRecoleccionConfirmar.vue';
  import $ from 'jquery';

  export default {
    name: 'GuiaMadreCrear',
    mixins: [GuiaCatalogo,Notificacion],
    data: () => {
      return {
        btnCliente: false,
        bc: 0,
        reg: '',
        hijas: [],
        actual: 1,
        madre: null,
        btnGuardar: false,
        depto: '',
        btipo: 1,
        listaCliente: [],
        tmpCliente: null,
        usarclie: false,
        rpoblado: 1,
        config:null,
        recolecta: null,
        autorizado: true,
        errorRecolecta: null,
        errorCobertura: null,
        guia: {
          unidad_medida_id: '',
          peso: null,
          contenido: null,
          peso_adicional: 0
        },
        documento: {
          tipo_id: '',
          numero: null,
          observaciones: null
        },
        form: {
          guia_tipo_servicio_id: '',
          guia_tipo_entrega_id: '',
          identificacion: '',
          guia_recoleccion_id: '',
          municipio_id: '',
          poblado_id: '',
          guias: [],
          documento: []
        },
        cltCargando: false,
        cltTipo: 1,
        cltNit: null,
        clt: {},
        solicitud: null,
        agenciaDestino: null,
        tipo_entrega: {}
      }
    },
    created() {
      this.getConfiguracion();
      this.getCatalogo([
        'unidad_medida',
        'departamento',
        'recoleccion',
        'tipo_servicio',
        'poblado',
        'guia_pago',
        'tipo_entrega',
        'bodega',
        'tipo_documento'
      ]);
    },
    methods: {
      guardar() {
        this.errorRecolecta = null;

        if (this.form.guias.length == 0) {
          this.showWarnMsg({message: 'Agregue detalle de bultos antes de guardar'});
          return false;
        }

        if (this.form.guia_tipo_servicio_id == 2 && this.form.cod_monto <= 0) {
          this.showWarnMsg({message: 'El monto CCE debe ser mayor a 0'});
          return false;
        }

        if (this.form.con_seguro == 1 && this.form.monto <= 0) {
          this.showWarnMsg({message: 'El monto o valor del producto debe ser mayor a cero.'});
          return false;
        }

        if (this.cltTipo == 2) {
          if (!this.clt.nombre || !this.clt.direccion || !this.cltNit) {
            this.showWarnMsg({message: 'El nit no es válido e ingrese los datos de facturación'});
            return false;
          }
        } else {
          this.clt.nit = 'CF';
          this.clt.nombre = 'Consumidor Final';
          this.clt.direccion = 'Ciudad';
        }

        if (this.form.con_liquidacion_documento == 1) {
          if (this.form.documento.length == 0) {
            this.showWarnMsg({message: 'Agregue documentos antes de guardar'});
            return false;
          }
        }

        if (confirm('¿Está seguro?')) {

          this.btnGuardar = true;

          if (this.form.guia_tipo_servicio_id == 3) {
            this.form.facturacion = this.clt;
          }

          axios
          .post(`${this.UrlBase}/madre/crear_guia`, this.form)
          .then(res => {
            this.btnGuardar = false;
            if (res.data.exito) {
              this.reg = res.data.reg;
              this.hijas = res.data.hijas;
              this.madre = res.data.madre;
              this.recolecta = res.data.recolecta;
              this.showSuccessMsg({message: `Guía #${this.madre.numero} creada.`});
            } else {
              this.errorRecolecta = res.data.mensaje;
              this.showErrorMsg({message: res.data.mensaje});
            }
          }).catch(e => {
            this.btnGuardar = false;
            alert('G Madre '+e);
          });
        }
      },
      agregarDetalle() {
        if (!this.form.guia_tipo_servicio_id) {
          this.showWarnMsg({message:'Seleccione un tipo de servicio'});
          return false;
        }

        if (parseInt(this.form.guia_tipo_servicio_id) != 1 &&
          this.form.guias.length == 1) {
          this.showWarnMsg({message: 'Solo para el tipo de servicio entrega regular se puede agregar más de un paquete'});
          return false;
        }

        if (this.guia.peso && 
          this.guia.contenido &&
          this.guia.unidad_medida_id) {

          let peso_adicional = 0;
          if (this.config.peso_maximo > 0 && 
            parseFloat(this.guia.peso) > this.config.peso_maximo) {
            peso_adicional = parseFloat(this.guia.peso)-parseFloat(this.config.peso_maximo);
          }

          let umedida = this.catalogo.unidad_medida.filter(e => {
            return e.id == this.guia.unidad_medida_id;
          })[0];

          this.form.guias.push({
            nunidad: umedida.nombre,
            peso: this.guia.peso,
            contenido: this.guia.contenido,
            unidad_medida_id: this.guia.unidad_medida_id,
            peso_adicional: peso_adicional
          });
          this.limpiarDetalle();
        } else {
          alert('Debe completar el formulario de detalle.')
        }
      },
      agregarDocumento() {
        if (this.documento.tipo_id && this.documento.numero) {
          let tipo = this.catalogo.tipo_documento.filter(o => {
            return o.id == this.documento.tipo_id;
          })[0];
          
          this.form.documento.push({
            ntipo: tipo.descripcion,
            tipo_id: this.documento.tipo_id,
            numero: this.documento.numero,
            observaciones: this.documento.observaciones
          })
          this.limpiarDocumento();
        } else {
          alert("Debe seleccionar un tipo de documento e indicar número.")
        }
      },
      limpiarDetalle() {
        for (let i in this.guia) {
          if (i !== 'unidad_medida_id') {
            this.guia[i] = '';
          }
        }
      },
      eliminaDetalle(key) {
        if (confirm('¿Está seguro?')) {
          this.form.guias.splice(key,1);
        }
      },
      limpiarDocumento() {
        for (let i in this.documento) {
          this.documento[i] = "";
        }
      },
      eliminaDocumento(key) {
        if (confirm("¿Está seguro?")) {
          this.form.documento.splice(key, 1);
        }
      },
      nuevo() {
        this.limpiarDetalle();
        this.limpiarDocumento();
        this.guia = {
          //unidad_medida_id: '',
          peso: null,
          contenido: null,
          peso_adicional: 0
        };
        this.documento = {
          tipo_id: null,
          numero: null,
          observaciones: null
        };
        this.form = {
          guia_tipo_servicio_id: '',
          guia_tipo_entrega_id: '',
          identificacion: '',
          guia_recoleccion_id: '',
          municipio_id: '',
          poblado_id: '',
          guias: [],
          documento: []
        };
        this.reg = '';
        this.hijas = [];
        this.madre = null;
        this.cltTipo = 1;
        this.cltNit = null;
        this.clt = {};
        this.solicitud = null
      },
      getCliente() {
        if (this.form.identificacion) {
          this.btnCliente = true;
          let datos = {identificacion: this.form.identificacion};
          if (this.btipo == 2) {
            datos = {nombre: this.form.identificacion};
          }

          axios
          .get(`${this.UrlBase}/catalogo/get_cliente`, {params:datos})
          .then(res => {
            if (res.data.existe) {
              if (this.btipo == 2) {
                this.listaCliente = res.data.cliente;
                $("#mdlResultado").modal();
              } else {
                this.setCliente(res.data.cliente);
              }
            } else {
              this.limpiarCliente();
              this.tmpCliente = null;
              this.usarclie = false;
              this.showInfoMsg({message: 'No existe un destinatario con la identificación ingresada, recuerde marcar la opción para guardar el destinatario.'});
            }
            this.btnCliente = false;
          }).catch(e => {
            alert('Cliente '+e);
            this.btnCliente = false;
          });
        } else {
          this.showErrorMsg({message: 'Ingrese la identificación del destinatario'});
        }
      },
      limpiarCliente() {
        this.bc = 0;
        this.form.cliente_id = '';
        this.form.nombre = null;
        this.form.correo = null;
        this.form.telefono = null;
        this.form.direccion = null;
      },
      setCliente(obj) {
        this.tmpCliente = obj;
        if (this.btipo == 2) {
          this.limpiarCliente();
          $("#mdlResultado").modal('hide');
        }

        this.form.cliente_id = obj.id;
        this.form.nombre     = obj.nombre;
        this.form.correo     = obj.correo;
        this.form.telefono   = obj.telefono;
        this.form.direccion  = obj.direccion;
        this.bc = 1;
      },
      getConfiguracion() {
        axios
        .get(`${this.UrlBase}/catalogo/get_configuracion`)
        .then(res => {
          this.config = res.data.config;
        });
      },
      getMunicipio() {
        let data = {
          tipo_entrega: this.form.guia_tipo_entrega_id
        };

        axios
        .get(`${this.UrlBase}/catalogo/get_municipio`, {params: data})
        .then(res => {
          this.catalogo.municipio = res.data.lista
        });
      },
      confirmar () {
        if (confirm('¿Está seguro?')) {
          $("#mdlSalida").modal()
        }
      },
      validarTiempo () {
        this.getMunicipio();
        //this.validarCobertura();
        if (this.form.guia_recoleccion_id && this.form.guia_tipo_entrega_id) {

          let datos = {
            recolecta: this.form.guia_recoleccion_id,
            entrega: this.form.guia_tipo_entrega_id
          };

          axios
          .post(`${this.UrlBase}/madre/validar_tiempo`, datos)
          .then(res => {
            if (res.data.exito) {
              this.autorizado = true;
              this.errorRecolecta = null;
            } else {
              this.errorRecolecta = res.data.mensaje;
              this.autorizado = false;
            }
          });
        }
      },
      duplicar (idx) {
        if (parseInt(this.form.guia_tipo_servicio_id) != 1 &&
          this.form.guias.length == 1) {
          this.showWarnMsg({message: 'Solo para el tipo de servicio entrega regular se puede agregar más de un paquete'});
          return false;
        }

        var cantidad = prompt("Ingrese la cantidad de veces que desea replicar:");

        for (var i = cantidad - 1; i >= 0; i--) {
          this.form.guias.push(this.form.guias[idx]);
        }
      },
      obtenerCliente() {
        if (this.cltNit) {
          this.cltCargando = true;
          this.clt = {};

          axios
          .get(`${this.UrlBase}/catalogo/validar_nit`, {params:{nit:this.cltNit}})
          .then(res => {
            if (res.data.exito) {
              this.clt = res.data.clt;
              this.showSuccessMsg({message: res.data.mensaje});

            } else {
              this.clt = {};
              this.showErrorMsg({message: res.data.mensaje});
            }

            this.cltCargando = false;
          }).catch(e => {
            this.cltCargando = true;
            alert('Nit ' + e);
          });
        }
      },
      setSolicitud() {
        if (this.solicitud) {
          this.form.guia_tipo_entrega_id = this.solicitud.guia_tipo_entrega_id
          this.form.guia_recoleccion_id  = this.solicitud.id

          this.tipo_entrega = this.catalogo.tipo_entrega.filter(o => o.id == this.solicitud.guia_tipo_entrega_id)[0]
          this.validarTiempo()
        }
      },
      setAgenciaDestino() {
        if (this.agenciaDestino) {
          this.form.agencia_destino_id = this.agenciaDestino.bodega
          this.depto                   = this.agenciaDestino.departamento_id
          this.form.municipio_id            = this.agenciaDestino.municipio
          this.form.direccion = this.agenciaDestino.direccion
        }
      }
    },
    computed: {
      municipios() {
        if (this.depto) {
          return this.catalogo.municipio.filter(o => {
            return o.departamento_id == this.depto
          });
        } else {
          return [];
        }
      },
      poblados () {
        if (this.form.municipio_id) {
          return this.catalogo.poblado.filter(o => {
            return o.municipio_id == this.form.municipio_id
          });
        } else {
          return [];
        }
      },
      getPesoMaximo () {
        for (let i in this.form.guias) {
          if (this.form.guias[i].peso_adicional > 0) {
            return true;
          }
        }

        return false;
      },
      validaMunicipioEntrega() {
        return this.form.guia_tipo_entrega_id && this.municipios.length == 0 && this.depto;
      }
    },
    watch: {
      'form.guia_tipo_servicio_id'() {
        this.form.cod_monto = 0;
      },
      usarclie (valor) {
        if (valor) {
          if (this.tmpCliente) {
            if (this.tmpCliente.departamento_id) {
              this.depto = this.tmpCliente.departamento_id;
            } else {
              this.showInfoMsg({message: 'El cliente no tiene departamento asignado.'});
            }

            if (this.tmpCliente.municipio_id) {
              this.form.municipio_id = this.tmpCliente.municipio_id;
            } else {
              this.showInfoMsg({message: 'El cliente no tiene municipio asignado.'});
            }
          } else {
            this.showInfoMsg({message:'No ha seleccionado un cliente.'});
          }
        } else {
          this.depto = '';
          this.form.municipio_id = '';
        }
      },
      'catalogo.unidad_medida' () {
        let tmp = this.catalogo.unidad_medida.filter(o => {
          return o.nombre == 'LB'
        })[0];

        if (tmp) {
          this.guia.unidad_medida_id = tmp.id;
        }
      },
      'form.municipio_id' (valor) {
        if (valor) {
          this.errorCobertura = null
          let tmp = this.catalogo.municipio.filter(o => {
            return o.id == valor
          })[0];

          if (tmp) {
            this.rpoblado = tmp.requiere_poblado;

            if (tmp.express_cobertura == 0) {
              this.errorCobertura = tmp.express_cobertura_comentario
              location.href = "#app"
            }
          } else {
            this.rpoblado = 0;
          }
        } else {
          this.rpoblado = 0;
        }
      },
      cltTipo (v) {
        if (v == 2) {
          this.clt = {};
          this.cltNit = null;
        }
      }
    },
    components: {
      GuiaMadreXls,
      GuiaRecoleccionConfirmar
    }
  }
</script>